import { useQuery } from '@tanstack/react-query';
import { GoogleGeoLocation } from '@blisspointmedia/bpm-types/dist/YoutubePlanning';
import { awaitJSON, YoutubePlanningLambdaFetch } from '@src/utils/fetch-utils';
import { ALL_STATES } from '../youtube-planning-constants';

// The master list of targetable states, with the synthetic "All States" option prepended so the
// states dropdown can offer a national selection. The endpoint takes no company, so the result is
// global and cached under a single key.
export const useTargetingLocations = (): ReturnType<typeof useQuery<GoogleGeoLocation[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['youtubeTargetingLocations'],
    queryFn: async (): Promise<GoogleGeoLocation[]> => {
      const res = await YoutubePlanningLambdaFetch('/getAllTargetingLocations', {
        method: 'GET'
      });
      const states = await awaitJSON<GoogleGeoLocation[]>(res);
      return [ALL_STATES, ...states];
    }
  });
